import Vue from 'vue';

Vue.component('audit-trail-index', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './audit-trail-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/audit-trail/index.js